module.exports = __webpack_public_path__ + "i18n/zh-TW.8d574e5d55219befe9c6b9e1406dd6d5.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1294
// module chunks = 60